import React from "react";
import Typography from "@material-ui/core/Typography";

const Instructions = () => {
  return (
    <div style={{ marginLeft: "4%" }}>
      <h1
        style={{
          fontStyle: "normal",
          fontFamily: "sans-serif",
          backgroundColor: "white",
          textAlign: "justify",
          textJustify: "inter-word",
          padding: "30px 70px",
        }}
      >
        INSTRUCTIONS
      </h1>

      <div style={{ backgroundColor: "yellow", borderRadius: "8%", marginTop: "5%", marginBottom: "5%" }}>
        <p style={{ padding: "2% 4% 2% 4%" }}>
          Both you and your spouse will need to complete and exchange your Declarations of Disclosure with one another. You will do this twice. You can use the Interview here to do all sets. Whoever's set you want to do, go to the <b>Profile Information </b> and select that person under the first question,<b> "Who are you? and click Save Details</b>"
        </p>
      </div>

      <Typography
        style={{
          fontFamily: "san-serif",
          marginBottom: "15px",
          marginLeft: "20px",
          fontSize: "18px",
        }}
      >
        You will need to complete and exchange your Declarations of Disclosure
        with your spouse. You will do this twice.
        <br />
        <br />
        <div>
          <b>Preliminary Disclosure</b>
          <p style={{ marginLeft: "18%" }}>
            You will do one set at the beginning of your case.{" "}
          </p>
        </div>
        <div>
          <b>Final Disclosure</b>
          <p style={{ marginLeft: "18%" }}>
            You will do the same set again (with updated information) at the
            end. You can both agree to waive the Final.{" "}
          </p>
        </div>
        <br />
        <p style={{ textAlign: "center" }}>
          <span style={{ backgroundColor: "yellow" }}> <b > Important: </b> This program does not support defaults, which has other rules.</span>
        </p>
        <br />

        <div>
          Prior to completing these forms, make sure you have watched the course
          instructions in your Thinkific platform, “Dividing Property and Debt,”
          and reviewed your flowchart and checklist
          <br />
          <br />

          <p>
            For Step 2. You have an option on which forms to use to complete
            your disclosures.
          </p>
          <div>
            <ul> <b> Option 1</b> </ul>
            <li style={{ marginLeft: "12%" }}>Income and Expense Declaration (FL-150)</li>
            <li style={{ marginLeft: "12%" }}>Schedule of Assets and Debts (FL-142)</li>
          </div>
          <div>
            <ul><b>Option 2</b></ul>
            <li style={{ marginLeft: "12%" }}>Income and Expense Declaration (FL-150)</li>
            <li style={{ marginLeft: "12%" }}>Property Declaration (FL-160) for Community Property</li>
            <li style={{ marginLeft: "12%" }}>Property Declaration (FL-160) for Separate Property (if any)</li>
          </div>
        </div>
        <br />
        <div>
          <p>You will select the forms you want to complete from the Step 2 Menu.</p>
          <p>
            If you are doing a Final Disclosure (and not waiving it - that’s in
            Step 4), then you need to do Step 2 twice.</p>
          <p>First time, go through the
            Acknowledgment Form and select Preliminary. Complete the disclosures.
            Then, download the forms, sign and exchange with your spouse.</p>
          <p>Then,
            come back when you are ready for the Final, and do it again.</p>
        </div>

      </Typography>
    </div>
  );
};

export default Instructions;
